import CategoriesLoop from '@/Components/Gallery/CategoriesLoop';
import ContactForm from '@/Components/Universal/ContactForm';
import TopHero from '@/Components/Universal/TopHero';
import FrontLayout from '@/Layouts/FrontLayout';
import { PageProps } from '@/types';
import { GalleryCategory } from '@/types/models/galleryCategory';
import { Head } from '@inertiajs/react';

export default function Gallery({ categories }: PageProps<{
    categories: GalleryCategory[]
}>) {
    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego'/>
            </Head>
            <FrontLayout>
                <TopHero image='general-breadcrumbs-bg.webp' text='Galeria'/>
                <CategoriesLoop categories={categories}/>
                <ContactForm smallerMargin/>
            </FrontLayout>
        </>
    );
}
